import FallingQuotesIndex from 'views/FallingQuotes/FallingQuotesIndex';
import ProfileForm from 'views/Profile/ProfileForm';
import ReportHotelsIndex from 'views/ReportHotels/ReportIndex';
import ReportOperatorsIndex from 'views/ReportOperators/ReportIndex';
import ReportSalesIndex from 'views/ReportSales/ReportSalesIndex';
import OperatorsIndex from 'views/Operators/OperatorsIndex';
import OperatorsForm from '../views/Operators/OperatorsForm';
import FallingQuotesForm from '../views/FallingQuotes/FallingQuotesForm';
import ReportClients from '../views/ReportClients/ReportIndex';
import basicRoutes from './basicRoutes';
import auth from '../lib/auth';
import HotelsForm from '../views/Hotels/HotelsForm';
import HotelsIndex from 'views/Hotels/HotelsIndex';

const authUser = auth.getCurrentUser();

var dashboardRoutes = [
  ...basicRoutes,
  {
    collapse: true,
    path: '/config',
    name: 'Configuracion',
    state: 'Configuracion',
    icon: 'pe-7s-box2',
    views: [
      {
        path: '/admin/config/operators/:id',
        name: 'Operadores',
        component: OperatorsForm,
        invisible: true,
      },
      {
        path: '/admin/config/operators',
        name: 'Operadores',
        icon: 'pe-7s-map-marker',
        component: OperatorsIndex,
      },
      {
        path: '/admin/profile',
        name: 'Perfil',
        icon: 'pe-7s-user',
        component: ProfileForm,
        invisible: false,
      },
    ],
  },
  {
    collapse: true,
    path: '/reports',
    name: 'Informes',
    state: 'Informes',
    icon: 'pe-7s-box2',
    views: [
      {
        path: '/admin/reports/falling-quotes/:id',
        name: 'Cotizaciones caídas',
        component: FallingQuotesForm,
        invisible: true,
      },
      {
        path: '/admin/reports/falling-quotes',
        name: 'Cotizaciones caídas',
        icon: 'pe-7s-attention',
        component: FallingQuotesIndex,
      },
      {
        path: '/admin/reports/sales',
        name: 'Reportes Ventas',
        icon: 'pe-7s-attention',
        component: ReportSalesIndex,
      },
      {
        path: '/admin/reports/hotels',
        name: 'Reportes Hoteles',
        icon: 'pe-7s-attention',
        component: ReportHotelsIndex,
      },
      {
        path: '/admin/reports/operators',
        name: 'Reportes Operadores',
        icon: 'pe-7s-attention',
        component: ReportOperatorsIndex,
      },
      {
        path: '/admin/reports/clients',
        name: 'Reporte de Clientes',
        icon: 'pe-7s-attention',
        component: ReportClients,
      },
    ],
  },

  { redirect: true, path: '/', pathTo: '/iniciar-sesion', name: 'Dashboard' },
];

if (authUser && authUser.roles.includes('adminHotel')) {
  const configMenu = dashboardRoutes.find((r) => r.name === 'Configuracion');
  if (configMenu && Array.isArray(configMenu.views)) {
    configMenu.views.unshift(
      {
        path: '/admin/config/hotels/:id',
        name: 'Hoteles',
        component: HotelsForm,
        invisible: true,
      },
      {
        path: '/admin/config/hotels',
        name: 'Hoteles',
        icon: 'pe-7s-map-marker',
        component: HotelsIndex,
        invisible: false,
      }
    );
  }
}
export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboardAdmin.jsx